import { render, staticRenderFns } from "./UploadedFileCardWithViewer.vue?vue&type=template&id=e74548f8&scoped=true"
import script from "./UploadedFileCardWithViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadedFileCardWithViewer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadedFileCardWithViewer.vue?vue&type=style&index=0&id=e74548f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74548f8",
  null
  
)

export default component.exports